<nav>
    <ul class="list-none p-0 m-0 mt-6 gap-2.5 flex flex-col">
        @for (
            mainPanel of managementSection() === ManagementSectionEnum.DATA ? dataPanel : organizationPanel;
            track mainPanel.value
        ) {
            @if (isUserAllowed(mainPanel.value)) {
                <li
                    class="item-box rounded cursor-pointer active-panel"
                    [class.active]="mainPanel.value === activePanel"
                    [class.disabled-panel]="!isUserAllowed(mainPanel.value)">
                    <button
                        class="custom-button px-6 py-2.5"
                        [disabled]="!isUserAllowed(mainPanel.value)"
                        [matTooltip]="'insufficientPermissions' | transloco"
                        [matTooltipDisabled]="isUserAllowed(mainPanel.value)"
                        (click)="selectMainPanel(mainPanel.value)">
                        <span class="text-lg truncate font-medium">{{ getPanelLabelKey(mainPanel) | transloco }}</span>
                    </button>
                </li>
            }
        }
    </ul>
</nav>
